<template>
<div id="header_lyout" class="header_lyout">
    <div class="header_lyout_content">
        <div class="header_lyout_content_menu">
            <div class="header_lyout_logo">
                <router-link to="/">
                    <img class="cursorPointer" :src="require('@/assets/images/general/header_logo.png')" alt="华略未来">
                </router-link>
            </div>

            <div class="header_lyout_menu">
                <horizontalMenu
                    :menuList="menuList"
                    @clickMenu="clickMenu">
                </horizontalMenu>
            </div>
        </div>

        <div class="header_lyout_userInfo">
            <router-link to="/login">
                <img class="header_lyout_login cursorPointer" :src="require('@/assets/images/general/header_login.png')" alt="">
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import menuConfig from "config/me_menu.config.js";
    import horizontalMenu from "components/custom-horizontal-menu/custom-horizontal-menu.vue";

    export default {
        components: {
            horizontalMenu
        },
        computed: {
            ...mapGetters(['userInfo','isRefresh','menuList']),
        },
        data() {
            return {
            };
        },
        watch:{
            // "$route":{
            //     handler(newRouter){
            //         this.isRefreshBreadcrumb = false;
            //         this.$nextTick(function(){
            //             this.isRefreshBreadcrumb = true;
            //         })
            //         // console.log("路由：",newRouter.path,this.editableTabsValue);
            //         let isHas=false;
            //         for (let index = 0; index < this.editableTabs.length; index++) {
            //             if(this.editableTabs[index].name==this.activeIndex){
            //                 isHas=true;
            //                 this.editableTabsValue = this.editableTabs[index].name;
            //                 this.setRouterKey(this.editableTabsValue,newRouter);
            //                 // console.log("有tab：",this.editableTabsValue);
            //                 break;
            //             }
            //         }
            //         //不存在
            //         if(!isHas){
            //             this.addTabOfMenus(this.menus,this.activeIndex,this.$route.path,true);
            //         }
            //     },
            //     immediate: true,//true刷新也会触发
            // },
        },
        created(){
           this.$store.state.app.menuList=menuConfig.menu;
        },
        mounted(){
            // this.onresizeChange();
            // this.autoShwoChange();

            // 窗口变化
            // window.onresize = () => {
            //     this.onresizeChange();
            // }

            // position: fixed;实现滚动
            window.onscroll =  () =>{
                //水平
                let sl = -Math.max(document.body.scrollLeft, document.documentElement.scrollLeft);
                //头部
                let layout_MyHeader=document.getElementById('header_lyout');
                if(layout_MyHeader){
                    layout_MyHeader.style.left = sl + 'px';
                }

                //竖直
                // this.autoShwoChange();
            }
        },
        methods: {
            clickMenu(item){//点击菜单
                if(this.$utils.isNoNullAll(item.routeUrl || item.path)){
                    this.$router.push({
                        path:item.routeUrl || item.path,
                    });
                }
            },
            clickLogin(){//登录
                this.$router.push({path:"/login"});
            },
            clickLogo(){//首页
                this.$router.push({path:"/"});
            },


            //登出
            signOut(){
                this.$storage.clear({});
                this.$store.state.user.userInfo={};
                this.$store.state.user.teacherRole={};
                setTimeout(()=>{
                    window.location.href=this.$constant.httpUrl.exitLogin;
                },"100");
            },
            onresizeChange(){//窗口变化
                let clientWidth=document.documentElement.clientWidth;
                if(clientWidth>1300){
                    this.anchorLeft=((clientWidth-1200)/2-40)/2||0;
                }else{
                    this.anchorLeft=5;
                }
                // console.log(document.documentElement.clientWidth,this.anchorLeft);
            },
            autoShwoChange(){//竖直
                let distance = document.documentElement.scrollTop || document.body.scrollTop;
                this.autoShwo=distance&&distance>5;
            }
        }
    }
</script>

<style lang="less" scoped>
@import '~utils/css/general.less';
@import '~utils/css/elementOften.less';
@import url("./custom-header.less");
</style>
